import { message, Alert, Input } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  SwitchItem,
  ErrorItem,
} from "../../../../../Components/Items";

class UsuarioEcommerceModal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    consultando: false,
    usarMatricula: false,
    matriculaCliente: "",
    tieneCuenta: false,
    cuentaInfo: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      this.cargarDatosModal();
    }
  }

  generarPasswordFecha = () => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, "0");
    const MM = String(now.getMonth() + 1).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const mm = String(now.getMinutes()).padStart(2, "0");
    return `${dd}${MM}${hh}${mm}`;
  };

  cargarDatosModal = async () => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      consultando: true,
      usarMatricula: false,
      matriculaCliente: "",
      tieneCuenta: false,
      cuentaInfo: null,
    });

    try {
      const [resCliente, resCuenta] = await Promise.all([
        axios.post(
          "clientes/datosCliente",
          {
            clienteId: this.props.clienteId,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        ),
        axios.post(
          "usuariosEcommerce/verificarCuentaEcommerceCliente",
          {
            clienteId: this.props.clienteId,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        ),
      ]);

      const matriculaCliente =
        resCliente?.data?.datosAlumno?.matricula?.trim() || "";

      const tieneCuenta = Boolean(resCuenta?.data?.tieneCuenta);
      const cuentaInfo = resCuenta?.data?.usuario || null;

      const usarMatriculaInicial =
        this.props.escuela && Boolean(matriculaCliente);

      this.setState({
        consultando: false,
        matriculaCliente,
        tieneCuenta,
        cuentaInfo,
        usarMatricula: usarMatriculaInicial,
      });

      if (this.formRef.current) {
        this.formRef.current.setFieldsValue({
          usarMatricula: usarMatriculaInicial,
          password: this.generarPasswordFecha(),
        });
      }
    } catch (err) {
      this.setState({ consultando: false });
      message.error("Error al cargar los datos del cliente");
    }
  };

  onFinishFailed = (e) => {
    ErrorItem(e);
  };

  onFinish = (values) => {
    const { usarMatricula } = this.state;

    if (usarMatricula) {
      if (!this.state.matriculaCliente) {
        message.error(
          "El cliente no tiene matrícula. Llénala en la pestaña Escuela y guarda primero."
        );
        return;
      }
    } else {
      if (!values?.correo || !values?.password) {
        message.info("Proporcione un correo y una contraseña");
        return;
      }
    }

    this.setState({ loading: true });

    axios
      .post(
        "usuariosEcommerce/crearUsuarioEcommerceManual",
        {
          clienteId: this.props.clienteId,
          empresaId: this.props.empresaId,
          usarMatricula,
          correo: usarMatricula ? undefined : values.correo,
          password: usarMatricula ? undefined : values.password,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data?.success) {
          message.success("Usuario de ecommerce creado correctamente");
          this.cerrarModal(true);
        } else {
          message.error(
            res.data?.message || "No se pudo crear el usuario de ecommerce"
          );
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        const msg =
          err?.response?.data?.message ||
          "Error al comunicarse con el servidor";
        message.error(msg);
      });
  };

  cerrarModal = (recargar = false) => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      usarMatricula: false,
      matriculaCliente: "",
      tieneCuenta: false,
      cuentaInfo: null,
    });
    this.props.cerrarModal(recargar);
  };

  renderEstadoCuenta = (estado) => {
    switch (estado) {
      case 0:
        return "Pendiente de verificación";
      case 1:
        return "Activa";
      case 2:
        return "Bloqueada";
      default:
        return "Desconocido";
    }
  };

  render() {
    const { escuela } = this.props;
    const {
      usarMatricula,
      matriculaCliente,
      consultando,
      tieneCuenta,
      cuentaInfo,
    } = this.state;
    const matriculaFaltante = usarMatricula && !matriculaCliente;

    return (
      <ModalItem
        title="Crear Usuario Ecommerce"
        visible={this.props.visible}
        spinning={this.state.loading || consultando}
        onCancel={() => this.cerrarModal(false)}
        width={500}
      >
        {tieneCuenta ? (
          <Alert
            type="success"
            showIcon
            message="Este cliente ya tiene una cuenta de ecommerce"
            description={
              <div>
                <div>
                  <b>Usuario:</b> {cuentaInfo?.correo || "—"}
                </div>
                <div>
                  <b>Estado:</b> {this.renderEstadoCuenta(cuentaInfo?.estado)}
                </div>
              </div>
            }
          />
        ) : (
          <Form
            ref={this.formRef}
            name="usuarioEcommerceModal"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
                loading={this.state.loading}
                disabled={matriculaFaltante || consultando}
              >
                Crear Usuario
              </ButtonItem>
            }
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
          >
            {escuela && (
              <FormItem
                label="Usar matrícula como usuario y contraseña"
                name="usarMatricula"
                valuePropName="checked"
                margin
                tooltip="Si está activo, se usará la matrícula del alumno como nombre de usuario y como contraseña."
              >
                <SwitchItem
                  onChange={(checked) =>
                    this.setState({ usarMatricula: checked })
                  }
                />
              </FormItem>
            )}

            {usarMatricula ? (
              matriculaCliente ? (
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 12 }}
                  message="Se creará la cuenta con la matrícula"
                  description={
                    <span>
                      Usuario y contraseña: <b>{matriculaCliente}</b>
                    </span>
                  }
                />
              ) : (
                <Alert
                  type="warning"
                  showIcon
                  style={{ marginBottom: 12 }}
                  message="El cliente no tiene matrícula registrada"
                  description="Ve a la pestaña Escuela, llena la matrícula y guarda los cambios antes de crear el usuario."
                />
              )
            ) : (
              <>
                <FormItem name="correo" label="Correo" required margin>
                  <InputItem placeholder="Ej: alumno@correo.com" />
                </FormItem>
                <FormItem name="password" label="Contraseña" required margin>
                  <Input.Password
                    placeholder="Contraseña inicial"
                    visibilityToggle
                  />
                </FormItem>
              </>
            )}

            <Alert
              type="info"
              showIcon
              style={{ marginTop: 8 }}
              message="La cuenta se creará verificada"
              description="No se enviará correo de verificación. El cliente podrá iniciar sesión inmediatamente."
            />
          </Form>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  escuela: state.empresa.escuela,
});

export default connect(mapStateToProps)(UsuarioEcommerceModal);
